import React from 'react';
import { bonuses } from '../data/kit';
export function BonusesSection() {
  return <section className="section ink" id="bonuses" data-id="element-12" data-mp="gvvj62v08yh8">
      <div className="wrap" data-id="element-13" data-mp="gxgdpshbkhf3">
        <div className="section-heading" data-id="element-14" data-mp="vswc29oxmzha">
          <p className="eyebrow" data-id="element-15" data-mp="vtxmcby4jhxy">Also included in your kit</p>
          <h2 data-id="element-16" data-mp="qtt8yusij3by">
            Five practical <span className="accent" data-id="element-17" data-mp="qsru0f8dlwoy">bonuses.</span>
          </h2>
          <p data-id="element-18" data-mp="14tkq34ebszu6">More support for indoor days, short gaps, group routines and the admin around your sessions.</p>
        </div>
        <div className="bonus-grid" data-id="element-19" data-mp="zv9hewzrovdj">
          {bonuses.map(bonus => <article key={bonus.number} className="bonus-card" data-id="element-20" data-mp="1ejdzpzuwr4vs">
              <div className="bonus-art" data-id="element-21" data-mp="1eim5asd1rd73">
                <img src={bonus.image} alt={`${bonus.title} cover`} loading="lazy" data-id="element-22" data-mp="19kkpcgax3tzu" />
              </div>
              <div className="bonus-copy" data-id="element-23" data-mp="1njkb9g71pusb">
                <p className="eyebrow" data-id="element-24" data-mp="1nkll5hcbsb8g">
                  BONUS {bonus.number} <span className="included-tag" data-id="element-25" data-mp="1jj9ur9lmnlz7">INCLUDED</span>
                </p>
                <h3 data-id="element-26" data-mp="3pqlj4z9kf46t">{bonus.title}</h3>
                <p data-id="element-27" data-mp="3prn4pxo7j92s">{bonus.description}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}